import React, { useEffect, useState } from "react";
import { Users, ShoppingBag, Package, DollarSign, Bell } from "lucide-react";
import { api, brl } from "@/lib/api";

export default function OverviewTab() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Orçamentos (leads)", value: stats?.leads_total ?? "—", icon: Users, sub: `${stats?.leads_new ?? 0} novos` },
    { label: "Pedidos do evento", value: stats?.orders_total ?? "—", icon: ShoppingBag, sub: `${stats?.orders_paid ?? 0} pagos` },
    { label: "Produtos cadastrados", value: stats?.products_total ?? "—", icon: Package, sub: "na loja" },
    { label: "Receita confirmada", value: stats ? brl(stats.revenue) : "—", icon: DollarSign, sub: "pedidos pagos" },
  ];

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="card-surface p-6" data-testid={`stat-${c.label}`}>
            <div className="flex items-center justify-between">
              <c.icon className="text-[var(--accent)]" />
              <Bell size={16} className="text-[var(--text-muted)]" />
            </div>
            <div className="text-3xl font-black mt-4">{c.value}</div>
            <div className="text-sm text-[var(--text-muted)] mt-1">{c.label}</div>
            <div className="text-xs text-[var(--accent)] mt-1">{c.sub}</div>
          </div>
        ))}
      </div>
      <div className="card-surface p-6 mt-6">
        <h3 className="font-head font-bold text-lg mb-2">Bem-vindo ao painel da K8</h3>
        <p className="text-[var(--text-muted)] text-sm">
          Aqui você edita tudo sem código: produtos, tamanhos, preços, galerias, depoimentos, dados de contato,
          redes sociais, campanha do evento e configuração do Mercado Pago. Campos deixados em branco ficam ocultos no site público.
        </p>
      </div>
    </div>
  );
}
